import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-system-unavailable',
    templateUrl: './system-unavailable.component.html',
    styleUrl: './system-unavailable.component.less',
    standalone: false
})
export class SystemUnavailableComponent implements OnChanges {

  @Input() error?: SystemUnavailableError;

  protected title: string = 'Service is temporarily unavailable';
  protected message: string = "System is currently unavailable. Please try again later.";
  protected footer: string = 'If you have further questions, please contact customer service.';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['error'] && this.error) { // check if error exists
      this.title = this.error.title || this.title;
      this.message = this.error.message || this.message;
      this.footer = this.error.footer || this.footer;
    }
  }
}


export interface SystemUnavailableError {
  title?: string;
  message?: string;
  footer?: string;
}